<div class="modal-header">
  <h4
    class="modal-title"
    i18n="
      label|Label for the section displaying current absence days in the modal@@CurrentAbsenceDays"
  >
    Current absence days
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    i18n-aria-label="
      accessible label|Accessible label for the close button of the timesheet info
      modal@@timesheetInfoModalCloseAriaLabel"
    (click)="closeModal()"
    [disabled]="absencesDaysService.isLoading()"
  ></button>
</div>
<div class="modal-body">
  <div
    class="text-muted"
    i18n="
      instruction|Instruction text guiding users to verify absence days and link to the absence
      app@@absenceVerificationInstruction"
  >
    Please make sure these are correct before proceeding. If not, go to the
    <a href="https://verlofaanvragen.abc-groep.be/" target="_blank">Absence app</a>
  </div>

  <table class="table table-sm table-striped">
    <thead>
      <tr>
        <th
          scope="col"
          i18n="column header|Column header for the date in the absence days table@@colDate"
        >
          Date
        </th>
        <th
          scope="col"
          i18n="column header|Column header for the absence type in the absence days table@@colType"
        >
          Type
        </th>
        <th
          scope="col"
          i18n="column header|Column header for the duration in the absence days table@@colDuration"
        >
          Duration
        </th>
      </tr>
    </thead>
    <tbody>
      @if (!absencesDaysService.isLoading()) {
        @for (abs of absenceDays(); track $index) {
          <tr>
            <td>{{ abs.date | date: 'EEE MMM dd, y' }}</td>
            <td>{{ abs.type }}</td>
            <td>{{ abs.duration }}</td>
          </tr>
        }
      } @else {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
    </tbody>
  </table>

  <span
    class="fw-bold"
    i18n="
      instruction|Instruction text guiding users to sync absences if out of
      sync@@absenceSyncInstruction"
  >
    If this does not match your timesheet, please sync absences using the dropdown under Auto-fill.
  </span>
</div>
<div class="modal-footer">
  <button
    class="btn btn-secondary"
    (click)="getAbsences()"
    [disabled]="absencesDaysService.isLoading()"
  >
    <i class="bi bi-arrow-clockwise"></i>
    <span
      class="ms-1"
      i18n="button|Button label for refreshing the absence days list@@refreshAbsences"
    >
      Refresh
    </span>
  </button>

  <button
    type="button"
    class="btn btn-primary"
    (click)="closeModal()"
    [disabled]="absencesDaysService.isLoading()"
    i18n="button|Close modal button@@timesheetInfoModalClose"
  >
    Correct
  </button>
</div>
